
import { IconChargingWire } from '@ds/icons/IconChargingWire'
import { IconQuality } from '@ds/icons/IconQuality'
import { IconWarning } from '@ds/icons/IconWarning'

import { MODAL_NAMES } from '@config/constants'
import IllustrationDeviceSmartphone from '@core/illustrations/IllustrationDeviceSmartphone.svg'
import { productExcludedAccessoriesFetch } from '@http/endpoints'

import AsyncModal from '../../../AsyncModal'
import ContentRow from '../../../ContentRow'

const ICONS = {
  IconChargingWire,
  IconQuality,
  IconWarning,
}

const ILLUSTRATIONS = {
  IllustrationDeviceSmartphone,
}

export default {
  components: {
    ContentRow,
    AsyncModal,
  },
  data() {
    return {
      accessories: {},
    }
  },
  computed: {
    modalName: () => MODAL_NAMES.PRODUCT.EXCLUDED_ACCESSORIES,

    modalTitle() {
      return this.accessories.title
    },

    excludedAccessories() {
      return this.accessories.paragraphs?.map(({ icon, title, text }) => ({
        icon: ICONS[icon],
        labels: [text],
        title,
      }))
    },
    illustration() {
      return ILLUSTRATIONS[this.accessories.image]
    },

    productId() {
      return this.$route.params.uuid
    },
  },
  methods: {
    async fetchExcludedAccessories() {
      const { payload } = await this.$store.dispatch('http/request', {
        request: productExcludedAccessoriesFetch,
        pathParams: { productId: this.productId },
      })

      this.accessories = { ...payload }
    },
  },
}
